import {ChangeDetectionStrategy, Component} from '@angular/core';
import {
  OpenLotteryListItemComponent
} from "../../../apartments-tab/components/open-lottery-list-item/open-lottery-list-item.component";
import {
  NotificationPage
} from "../../../../services/notification/multi-page-notification/multi-page-notification.component";
import {
  LotteriesDialogContentComponent,
  LotteryDialogListItemDirective
} from "../../../../services/notification/notification-dialog-content/lotteries-dialog-content/lotteries-dialog-content.component";

@Component({
  selector: 'homey-eligibility-changes-dialog',
  imports: [
    OpenLotteryListItemComponent,
    LotteriesDialogContentComponent,
    LotteryDialogListItemDirective
  ],
  templateUrl: './eligibility-changes-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EligibilityChangesDialogComponent extends NotificationPage<{ lotteries: string[] }>{
}
